// we track line number here - so don't move stuff around
import log from 'uix/logging'

export function* _triggerSagaError({payload}) {
  log.info('trigger saga error')
  throw Error('bad things') // needs to be on line 6
  // there should'nt be any SagaErrors as everybody wraps their sagas
  // in try/catch constructs, right?
}
